import styled from 'styled-components'
import { TOPBAR_HEIGHT_NUMBER, HEADER_HEIGHT_NUMBER } from '@/v2/constants'

const PATIENT_HEADER_HEIGHT = 80
const PATIENT_HEADER_HEIGHT_SMALL = 70
const TOTAL_TOP_HEIGHT =
  TOPBAR_HEIGHT_NUMBER + HEADER_HEIGHT_NUMBER + PATIENT_HEADER_HEIGHT
const TOTAL_TOP_HEIGHT_SMALL =
  TOPBAR_HEIGHT_NUMBER + HEADER_HEIGHT_NUMBER + PATIENT_HEADER_HEIGHT_SMALL

export const ConversationWrapper = styled.div`
  width: calc(100% - 260px);
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 1200px) {
    width: calc(100% - 240px);
  }
`

export const ConversationContent = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  width: 100%;
  height: calc(100vh - ${TOTAL_TOP_HEIGHT}px);
  max-height: calc(100vh - ${TOTAL_TOP_HEIGHT}px);
  overflow: hidden;

  @media (max-width: 1200px) {
    height: calc(100vh - ${TOTAL_TOP_HEIGHT_SMALL}px);
    max-height: calc(100vh - ${TOTAL_TOP_HEIGHT_SMALL}px);
  }
`

export const RightBar = styled.div`
  width: 260px;
  min-width: 240px;
  border-left: 1px solid ${({ theme }) => theme.primary.main};
  overflow: auto;
  flex-shrink: 0;

  @media (max-width: 1200px) {
    width: 240px;
    min-width: 220px;
  }

  @media (max-width: 1100px) {
    width: 220px;
    min-width: 200px;
  }
`

export const SelectConversation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`
